import { useState } from 'react';

export function useFileHubSearch() {
  const [linkSearch, setLinkSearch] = useState('');
  const [linkResults, setLinkResults] = useState([]);
  const [linkOpen, setLinkOpen] = useState(false);
  const [partySearch, setPartySearch] = useState('');
  const [partyResults, setPartyResults] = useState([]);
  const [partyOpen, setPartyOpen] = useState(false);

  return {
    linkSearch, setLinkSearch,
    linkResults, setLinkResults,
    linkOpen, setLinkOpen,
    partySearch, setPartySearch,
    partyResults, setPartyResults,
    partyOpen, setPartyOpen,
  };
}
